import { preferredLanguageAtom } from '@openeducation/oe-rn-jotai-atoms';
import type { Environment } from '@openeducation/oe-rn-services';
import type { Language } from '@openeducation/oe-rn-shared-types';
import { OeDefaultTheme, ThemeProvider } from '@openeducation/oe-rn-themes';
import { useSetAtom } from 'jotai';
import React from 'react';

import { EnvironmentProvider } from '../environment/environment.provider';
import { LocalizationProvider } from '../localization/localization.provider';

interface IFrameAppProvidersProps {
  env: Environment;
  language: Language;
  loadingComponent?: React.ReactNode;
  children?: React.ReactNode;
}

export const IFrameAppProviders: React.FC<IFrameAppProvidersProps> = ({
  children,
  env,
  language,
  loadingComponent,
}) => {
  const setLanguageAtom = useSetAtom(preferredLanguageAtom);

  React.useEffect(() => setLanguageAtom(language), [language, setLanguageAtom]);

  return (
    <EnvironmentProvider env={env}>
      <LocalizationProvider
        language={language}
        environment={env}
        loadingComponent={loadingComponent}
      >
        <ThemeProvider
          theme={OeDefaultTheme}
          loadingComponent={loadingComponent}
        >
          {children}
        </ThemeProvider>
      </LocalizationProvider>
    </EnvironmentProvider>
  );
};
